export default [
  '1-fc-koln',
  'ac-ajaccio',
  'ac-milan',
  'ac-monza',
  'acf-fiorentina',
  'afc-eskilstuna',
  'aik-fotboll',
  'aik-hockey',
  'ajaccio',
  'almeria',
  'almtuna',
  'angers-sco',
  'angers',
  'arsenal',
  'as-monaco',
  'as-roma',
  'aston-villa',
  'atalanta-bc',
  'atalanta',
  'athletic-bilbao',
  'atletico-madrid',
  'augsburg',
  'auxerre',
  'barcelona',
  'bayer-leverkusen',
  'bayern-munchen',
  'birmingham',
  'bjorkloven',
  'bk-hacken',
  'blackburn',
  'blackpool',
  'bochum',
  'bologna-fc',
  'bologna',
  'borussia-dortmund',
  'bournemouth',
  'brage',
  'brentford-fc',
  'brentford',
  'brest',
  'brighton',
  'bristol',
  'brommapojkarna',
  'brynas',
  'burnley',
  'bvb',
  'ca-osasuna',
  'cadiz-cf',
  'cadiz',
  'cardiff',
  'celta-de-vigo',
  'chelsea',
  'clermont-foot',
  'clermont',
  'coventry',
  'cremonese',
  'crystal-palace',
  'degerfors',
  'dif-fotboll',
  'dif-hockey',
  'eintracht-frankfurt',
  'elche-cf',
  'elche',
  'elfsborg',
  'empoli',
  'es-troyes-ac',
  'eskilstuna',
  'espanyol',
  'everton',
  'farjestad',
  'fc-augsburg',
  'fc-barcelona',
  'fc-inter-milano',
  'fc-lorient',
  'fc-nantes',
  'fiorentina',
  'freiburg',
  'frolunda',
  'fulham',
  'gais',
  'gefle-if-ff',
  'gefle-if',
  'getafe-cf',
  'getafe',
  'gif-sundsvall',
  'girona',
  'halmstad',
  'hammarby-fotboll',
  'hellas-verona',
  'helsingborg',
  'hertha-bsc',
  'hertha',
  'hoffenheim',
  'huddersfield',
  'hull',
  'hv71',
  'ifk-goteborg',
  'ifk-norrkoping',
  'ifk-varnamo',
  'ik-sirius',
  'inter',
  'jonkopings-sodra',
  'juventus-fc',
  'juventus',
  'kalmar-ff',
  'karlskoga',
  'koln',
  'kristianstad',
  'kristianstads-ik',
  'landskrona-bois',
  'lazio',
  'lecce',
  'leeds',
  'leicester',
  'leksand',
  'lens',
  'lille',
  'linkoping-hc',
  'liverpool',
  'lorient',
  'losc-lille',
  'lulea',
  'luton',
  'lyon',
  'mainz-05',
  'mainz',
  'mallorca',
  'malmo-ff',
  'malmo-redhawks',
  'man-city',
  'man-united',
  'manchester-city',
  'manchester-united',
  'marseille',
  'middlesbrough',
  'milan',
  'millwall',
  'mjallby',
  'modo',
  'monaco',
  'monchengladbach',
  'montpellier-hsc',
  'montpellier',
  'monza',
  'mora',
  'nantes',
  'napoli',
  'newcastle',
  'nice',
  'norwich-city',
  'norwich',
  'nottingham',
  'ogc-nice',
  'olympique-lyon',
  'olympique-marseille',
  'orebro-hk',
  'orebro-sk',
  'orgryte',
  'osasuna',
  'oskarshamn',
  'oster',
  'ostersund',
  'ostersunds-fk',
  'ostersunds-ik',
  'paris-saint-germain',
  'preston',
  'psg',
  'qpr',
  'queens-pr',
  'rayo-vallecano',
  'rb-leipzig',
  'rc-lens',
  'rcd-espanyol',
  'rcd-mallorca',
  'reading',
  'real-betis',
  'real-madrid',
  'real-sociedad',
  'real-valladolid',
  'reims',
  'rennais',
  'rogle',
  'roma',
  'rotherham',
  'salernitana',
  'sampdoria',
  'sassuolo',
  'sc-freiburg',
  'schalke-04',
  'schalke',
  'sevilla-fc',
  'sevilla',
  'sheffield-united',
  'sheffield',
  'skelleftea',
  'skovde-aik',
  'sodertalje',
  'southampton',
  'spezia-calcio',
  'spezia',
  'ss-lazio',
  'ssc-napoli',
  'stade-de-reims',
  'stade-rennais',
  'stoke',
  'strasbourg',
  'stuttgart',
  'sunderland',
  'swansea',
  'timra-ik',
  'tingsryd',
  'torino-fc',
  'torino',
  'tottenham',
  'toulouse',
  'trelleborg',
  'troyes',
  'tsg-hoffenheim',
  'uc-sampdoria',
  'udinese-calcio',
  'udinese',
  'union-berlin',
  'us-cremonese',
  'us-sassuolo',
  'utsikten',
  'utsiktens-bk',
  'valencia-cf',
  'valencia',
  'varberg',
  'vasteras-ik',
  'vasteras-sk',
  'vastervik',
  'vaxjo-lakers',
  'vfb-stuttgart',
  'vfl-bochum',
  'vfl-wolfsburg',
  'villarreal-cf',
  'villarreal',
  'vita-hasten',
  'watford-fc',
  'watford',
  'werder-bremen',
  'west-brom',
  'west-bromwich',
  'west-ham',
  'wigan',
  'wolfsburg',
  'wolverhampton'
]